import { NgModule } from '@angular/core';
import { ClipboardModule } from '@angular/cdk/clipboard';

import { CordovaModule } from './modules/cordova/cordova.module';
import { CrowdinLoaderModule } from './modules/crowdin-loader/crowdin-loader.module';
import { NavigateBackModule } from './modules/navigate-back/navigate-back.module';
import { RecaptchaModule } from './modules/recaptcha/recaptcha.module';
import { TranslateModule } from './modules/translate/translate.module';

@NgModule({
  exports: [NavigateBackModule, RecaptchaModule, TranslateModule],
  imports: [CrowdinLoaderModule, ClipboardModule, CordovaModule, NavigateBackModule, RecaptchaModule, TranslateModule],
  providers: [{ provide: 'Window', useValue: window }]
})
export class SharedModule {}
